export enum DiscoverySource {
  SOCIAL_MEDIA = 'social_media',
  NEWSPAPER = 'newspaper',
  WEBSITE = 'website',
  FRIENDS_AND_ACQUAINTANCES = 'friends_and_acquaintances',
  RECOMMENDATION = 'recommendation',
  FROM_THE_AREA = 'from_the_area',
  INTERNET = 'internet',
  SEARCH_ENGINE = 'search_engine',
  ALREADY_KNOWN = 'already_known',
}
